interface GoalSelectorProps {
  goal: string;
  onGoalChange: (goal: string) => void;
  disabled?: boolean;
}

const GOALS = [
  { value: '', label: 'All Goals' },
  { value: 'efficiency', label: 'Efficiency (Lower CPA)' },
  { value: 'scale', label: 'Scale (More Conversions)' },
  { value: 'max_revenue', label: 'Max Revenue (ROAS)' },
];

export default function GoalSelector({ goal, onGoalChange, disabled }: GoalSelectorProps) {
  return (
    <select
      className="command-bar-select"
      value={goal}
      onChange={(e) => onGoalChange(e.target.value)}
      disabled={disabled}
      title="Optimization goal"
    >
      {GOALS.map((g) => (
        <option key={g.value} value={g.value}>{g.label}</option>
      ))}
    </select>
  );
}
